import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      nav("/dashboard");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Registration failed");
    } finally { setLoading(false); }
  };

  const startGoogle = () => {
    const redirect = `${window.location.origin}/login`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="register-page">
      <h1 className="font-serif text-4xl text-[#F7ECEB]">Create your account.</h1>
      <p className="text-[#A89896] mt-3">Private, discreet, and always yours.</p>

      <form onSubmit={submit} className="mt-10 space-y-5">
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-[#C93B3B] mb-2">Name</label>
          <input
            data-testid="register-name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required minLength={1}
            className="w-full px-4 py-3 border border-[#382A2A] rounded-xl bg-[#1F1717] focus:border-[#C93B3B] outline-none"
          />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-[#C93B3B] mb-2">Email</label>
          <input
            data-testid="register-email"
            type="email" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
            className="w-full px-4 py-3 border border-[#382A2A] rounded-xl bg-[#1F1717] focus:border-[#C93B3B] outline-none"
          />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.2em] text-[#C93B3B] mb-2">Password</label>
          <input
            data-testid="register-password"
            type="password" value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required minLength={6}
            className="w-full px-4 py-3 border border-[#382A2A] rounded-xl bg-[#1F1717] focus:border-[#C93B3B] outline-none"
          />
        </div>
        {err && <div className="text-sm text-red-700" data-testid="register-error">{err}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit">
          {loading ? "Creating..." : "Create account"}
        </button>
      </form>

      <div className="my-6 flex items-center gap-4 text-xs text-[#A89896] uppercase tracking-[0.2em]">
        <div className="flex-1 h-px bg-[#382A2A]" /> or <div className="flex-1 h-px bg-[#382A2A]" />
      </div>

      <button onClick={startGoogle} className="btn-ghost w-full" data-testid="register-google">
        Continue with Google
      </button>

      <p className="text-sm text-[#A89896] mt-8 text-center">
        Already a member? <Link to="/login" className="text-[#C93B3B] underline" data-testid="register-to-login">Sign in</Link>
      </p>
    </div>
  );
}
